import React from 'react';
import { Award, Shield, CheckCircle, FileCheck } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/card';
import { certifications } from '../mockData';

const iconMap = {
  Award,
  Shield,
  CheckCircle,
  FileCheck
};

const Certifications = () => {
  return (
    <section id="certifications" className="py-24 bg-black relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Licensed & Certified
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto mb-6"></div>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Your safety and satisfaction are our top priorities
          </p>
        </div>

        {/* Certifications Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {certifications.map((cert) => {
            const IconComponent = iconMap[cert.icon];
            return (
              <Card 
                key={cert.id}
                className="group text-center bg-white/5 backdrop-blur-sm border-2 border-gold/20 hover:border-gold hover:bg-white/10 transition-all duration-300"
              >
                <CardHeader className="p-8">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/20 mx-auto mb-6 group-hover:bg-gold/30 transition-colors">
                    <IconComponent className="w-8 h-8 text-gold" />
                  </div>
                  <CardTitle className="text-xl mb-3 text-white">
                    {cert.title}
                  </CardTitle>
                  <CardDescription className="text-gray-300">
                    {cert.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
